import { Routes, RouterModule } from '@angular/router';

export const Approutes: Routes = [
  {
    path: '',
    loadChildren : () => import('./visitor/visitor.module').then(m => m.VisitorModule)
  },
  {
    path: '**',
    redirectTo: ''
  }
];
